import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const HowItWorks = () => {
  const navigate = useNavigate();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30, scale: 0.95 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  // Floating animation
  const floatingAnimation = {
    y: [0, -8, 0],
    transition: {
      duration: 2.5,
      repeat: Infinity,
      ease: "easeInOut",
    },
  };

  const handleFindWorkClick = () => {
    navigate("/find-work");
  };

  const handleFindWorkerClick = () => {
    navigate("/find-worker");
  };

  const handleRegisterClick = () => {
    navigate("/register");
  };

  return (
    <section className="py-12">
      {/* Animated Heading */}
      <motion.h1
        className="text-3xl font-bold text-gray-800 text-center mb-8"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        How it works?
      </motion.h1>

      {/* Steps */}
      <motion.div
        className="flex flex-wrap justify-center items-stretch gap-8 mt-8 mb-8 max-w-5xl mx-auto"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {/* Workers */}
        <motion.div
          variants={cardVariants}
          className="bg-gray-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 flex flex-col items-center"
        >
          {/* Floating Emoji */}
          <motion.span className="text-6xl mb-4" animate={floatingAnimation}>
            👷‍♂️
          </motion.span>

          <h3 className="text-xl font-semibold mb-4 text-blue-600">For Workers</h3>
          <ol className="list-decimal list-inside text-gray-600 text-sm mb-6 space-y-1">
            <li>Create a free account</li>
            <li>Post your availability, skills, and location</li>
            <li>Find casual jobs matching your availability</li>
            <li>Contact employers directly & get hired quickly</li>
            <li>Work jobs that suit your skills</li>
          </ol>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleFindWorkClick}
            className="bg-blue-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-blue-600 transition duration-300 mb-3"
          >
            Find Work
          </motion.button>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleRegisterClick}
            className="bg-orange-700 text-white font-semibold py-2 px-4 rounded-lg hover:bg-gray-800 transition duration-300"
          >
            Sign Up Free
          </motion.button>
        </motion.div>

        {/* Employers */}
        <motion.div
          variants={cardVariants}
          className="bg-gray-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 flex flex-col items-center"
        >
          {/* Floating Emoji */}
          <motion.span className="text-6xl mb-4" animate={floatingAnimation}>
          🧑‍💼
          </motion.span>

          <h3 className="text-xl font-semibold mb-4 text-green-600">For Employers</h3>
          <ol className="list-decimal list-inside text-gray-600 text-sm mb-6 space-y-1">
            <li>Create an account</li>
            <li>Get an affordable Skilled Mates membership</li>
            <li>Find workers by skills, location & availability</li>
            <li>Post jobs & access a pool of qualified workers</li>
            <li>Contact workers directly & negotiate pay</li>
            <li>No commission — only a monthly membership</li>
          </ol>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleFindWorkerClick}
            className="bg-green-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-green-600 transition duration-300 mb-3"
          >
            Find Workers
          </motion.button>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleRegisterClick}
            className="bg-orange-700 text-white font-semibold py-2 px-4 rounded-lg hover:bg-gray-800 transition duration-300"
          >
            Join Now
          </motion.button>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HowItWorks;
